import React from "react";

export default function Badge() {
  return (
    <div className="garunteebadge" id="garunteeBadge">
      <div className="container">
        <div className="row">
          <div className="col-md-2">
            <img src={"../assets/img/badgeimg.png"} alt="Guarantee Badge" className="badgeimg" />
          </div>
          <div className="col-md-10">
            <div className="badge-title">
              Price Meet or Beat <span className="colorchange">Guarantee.</span>
              <sup>
                <i className="fa fa-info-circle pricemeetinfo" aria-hidden="true"></i>
              </sup>
              <div className="pmInformation">
                <p style={{ fontWeight: "600", color: "#005282" }}>Price Match Guarantee (PMG)</p>
                <p>
                  We offer the cheapest airfares for travelers booking flights on cheapflightsprices.com.
                  We search and scan thousands of airlines and service providers to come up with ultra-low-cost airfares.
                  You can rest assured for the best price when you book your air ticket with us.
                </p>
              </div>
              No one can match our fares.
            </div>
            <div className="badgedescription d-none d-md-block">
              We take pride in our exclusive bargain fares. We search and scan thousands of airlines and service providers
              to come up with ultra-low-cost airfares.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
